import React, { CSSProperties } from 'react';
import { IconButton } from '@cad-arc';
import { Content, Footer, Header, HeaderText, Modal, PanelOverlay } from './panel-modal.styled';

export function PanelModal({
    body,
    header,
    footer,
    isCloseable = true,
    onClose = () => {},
    style = {},
}: {
    body: React.ReactNode;
    header?: React.ReactNode;
    footer?: React.ReactNode;
    isCloseable?: boolean;
    onClose?: () => void;
    style?: CSSProperties;
}): React.ReactElement {
    return (
        <PanelOverlay>
            <Modal style={style}>
                <Header>
                    <HeaderText>{header}</HeaderText>
                    {isCloseable && (
                        <IconButton onClick={onClose} icon="CloseX" aria-label="close" />
                    )}
                </Header>
                <Content>{body}</Content>
                <Footer>{footer}</Footer>
            </Modal>
        </PanelOverlay>
    );
}
